const initialState = {
    isLoading: false,
    errors: [],
    successMessage: undefined
}

const uxReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'IS_LOADING':
            return {
                ...state,
                isLoading: action.payload
            }
        case 'SET_ERRORS':
            return {
                ...state,
                errors: action.payload
            }
        case 'SET_SUCCESS_MESSAGE':
            return {
                ...state,
                successMessage: action.payload
            }
        default:
            return state
    }
}

export default uxReducer
